import { render, staticRenderFns } from "./ShowTransactionProvider.vue?vue&type=template&id=1c683462&"
import script from "./ShowTransactionProvider.vue?vue&type=script&lang=js&"
export * from "./ShowTransactionProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports